import { render } from "./menu-button.vue?vue&type=template&id=5d6530ab"
import script from "./menu-button.vue?vue&type=script&lang=js"
export * from "./menu-button.vue?vue&type=script&lang=js"

import "./menu-button.vue?vue&type=style&index=0&id=5d6530ab&lang=scss"
script.render = render

export default script